<template>
  <main><app-steps></app-steps></main>
</template>
<script setup>
import AppSteps from '@modules/app-steps/index.vue'
</script>
